export const OrderDetailsShimmer = () => {
  return (
    <div className="flex flex-col min-h-[100dvh] animate-pulse bg-bodyBgColor">
      <div className="flex-1 mb-3 relative md:max-w-7xl mx-auto px-4 sm:px-4 2xl:px-0 lg:px-8 pt-5 md:pb-4 pb-0">
        <div className="flex flex-col lg:flex-row gap-4">
          {/* Left Section */}
          <div className="w-full lg:w-2/3 bg-white p-5 rounded">
            {/* Title */}
            <div className="h-8 bg-gray-300 rounded mb-4 w-full" />

            {/* Inputs */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="h-10 bg-gray-300 rounded" />
              <div className="h-10 bg-gray-300 rounded" />
            </div>

            <div className="h-16 bg-gray-300 rounded mb-4" />

            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="h-10 bg-gray-300 rounded" />
              <div className="h-10 bg-gray-300 rounded" />
            </div>

            {[1, 2, 3].map((_, i) => (
              <div key={i} className="flex gap-3 items-center border-b py-3">
                <div className="h-16 w-16 bg-gray-300 rounded" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-3/4 bg-gray-300 rounded" />
                  <div className="h-4 w-1/2 bg-gray-300 rounded" />
                </div>
                <div className="h-6 w-16 bg-gray-300 rounded" />
              </div>
            ))}
          </div>

          {/* Right Section */}
          <div className="w-full lg:w-1/3 space-y-4">
            <div className="bg-white p-5 rounded space-y-3 w-full">
              <div className="h-6 w-1/2 mx-auto bg-gray-300 rounded" />
              <div className="h-10 bg-gray-300 rounded" />
              <div className="h-10 bg-gray-300 rounded" />
              <div className="h-10 bg-gray-300 rounded" />
            </div>

            <div className="bg-white p-5 rounded space-y-3 w-full">
              <div className="h-6 w-1/2 mx-auto bg-gray-300 rounded" />
              <div className="h-4 bg-gray-300 rounded" />
              <div className="h-4 bg-gray-300 rounded" />
              <div className="h-10 bg-gray-300 rounded mt-3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
